import { render } from "./AppHeaderDropdownAccnt.vue?vue&type=template&id=6465db9f"
import script from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__